import { API, graphqlOperation } from "aws-amplify";
import { listInterviewResourceBySubjectId } from "graphql/queries";
import {
  InterviewResource,
  ListInterviewResourceBySubjectIdQuery,
} from "types/graphqlapi";

/**
 * 同一案件のインタビューリソースリストを取得
 * @param subjectId
 * @returns
 */
export const fetchInterviewResourcesBySubjectIdQuery = async (
  subjectId: string
) => {
  const result = (await API.graphql(
    graphqlOperation(listInterviewResourceBySubjectId, {
      subject_id: subjectId,
      limit: 1000,
    })
  )) as {
    data: ListInterviewResourceBySubjectIdQuery;
  };

  const list = result.data?.listInterviewResourceBySubjectId
    ?.items as InterviewResource[];

  return list;
};
